import { render } from "./MedicationsListDialog.vue?vue&type=template&id=85087bf4&scoped=true"
import script from "./MedicationsListDialog.vue?vue&type=script&lang=js"
export * from "./MedicationsListDialog.vue?vue&type=script&lang=js"

import "./MedicationsListDialog.vue?vue&type=style&index=0&id=85087bf4&lang=css"
import "./MedicationsListDialog.vue?vue&type=style&index=1&id=85087bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85087bf4"]])

export default __exports__